<div class="article-content">
  <ng-container *ngIf="page$">
    <ng-container *ngIf="page$ | async as page">
      <div *ngFor="let module of page.modules">
        <article
          *ngIf="module.module === 'RichTextArea'"
          [innerHTML]="module.item.fields['textblob'] | bypassSecurityHtml"
        ></article>
        <article
          *ngIf="module.module === 'Versioning'"
          [innerHTML]="module.item.fields['content'] | bypassSecurityHtml"
        ></article>
      </div>
    </ng-container>
  </ng-container>
</div>
